<ng-container *transloco="let t">
  @let parameters = question().parameters;
  @let placeholder =
    parameters?.placeholder ??
    (unit() ? t('{{ title }} en {{ unit }}', { title: question().title, unit: unit() }) : question().title);
  <tui-textfield class="w-full" [iconStart]="iconStart()">
    <input
      data-testid="number-input"
      ngDefaultControl
      tuiInputNumber
      [formControl]="control()"
      [placeholder]="placeholder"
      [postfix]="postfix()"
      [readOnly]="readOnly()"
      [step]="$safeNavigationMigration(parameters?.step)"
      [tuiNumberFormat]="numberFormat"
      [tuiTextfieldCleaner]="false" />
  </tui-textfield>
</ng-container>
